import moment from "moment";
import { useReducer } from "react";
import ClientContext, { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../../utils/helpers/execute";
import EndPoints from "../../../services/end-points";
import { ICreateClient, IUpdateClient } from "../../../models/client/request";
import { IClient } from "../../../models/client/response";
import { IClientQuery } from "../../../models/client/query";
import getApiErrorMessage from "../../../utils/api/get-api-error-message";
import { errorNotification } from "../../../utils/helpers/notification";
import i18n from "../../../utils/localization/i18n";

export interface IProps {
  children: React.ReactNode;
}
const ClientContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.client.getAllClient(state.query);

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });

        const { data } = await EndPoints.client.getClient(id);
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = async (data?: IClient) => {
    // dispatch({ type: 'SET_DETAILSS', payload: { details: data } })
  };

  const createClient = async (request: ICreateClient) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.client.createClient(request);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const updateClient = async (id: number, request: IUpdateClient) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.client.updateClient(id, request);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

  const deleteClient = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.client.deleteClient(id);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: IClientQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };

  const getExportQuery = (): IClientQuery => {
    const { page, perPage, total, filters, orders, keyword, ...exportQuery } =
      state.query;

    return {
      ...exportQuery,
      ...(keyword ? { keyword } : {}),
      ...(filters?.length ? { filters } : {}),
      ...(orders?.length ? { orders } : {}),
    };
  };

  const exportExcel = async (request: any) => {
    return await execute<boolean>({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const data = await EndPoints.client.exportExcel(request, getExportQuery());
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Clients-${moment().format("yyyy-MM-d")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        return true;
      },
      fallback: (error) => {
        errorNotification(
          getApiErrorMessage(error, i18n.t("server_error_try_again"))
        );
      },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: false,
    });
  };

  return (
    <ClientContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,
          setDetails,
          createClient,
          updateClient,
          deleteClient,
          exportExcel,
          setSearch,
          setQuery,
        },
      }}
    >
      {props.children}
    </ClientContext.Provider>
  );
};

export default ClientContextProvider;
